export default "__VITE_ASSET__Bdob_td3__"